@if (showAlert) {
  <div data-alert class="alert-box text-align-center">
    <span class="vertical-align-middle">{{message}}</span>
    <a (click)="close()" class="close vertical-align-middle">&times;</a>
  </div>
}